<template>
  <!-- <div class="hs-article-wrap"> -->
  <div
    class="hsarticle"
    :class="[
      size ? 'hsarticle-' + size : '',
      { 'not-subscribe': notSubscribe },
    ]"
  >
    <div v-if="tags" class="hsarticle__tags">
      <Tag
        v-if="classification"
        :text="classification"
        :color="'green'"
        :background="'gray'"
        :class="setTagColour(classification)"
      />
      <Tag
        v-for="(tag, index) in tags.filter((item, index) => index < 3)"
        :key="index"
        :text="tag.title"
        :color="'brightgreen'"
        :background="'gray'"
        :link="setTagURL(tag, 'jurisdictions')"
        :uuid="tag.uuid"
        :tid="tag.tid"
        :class="
          watchlistTags && watchlistTags.find((el) => tag.tid === el)
            ? 'red'
            : null
        "
      />
    </div>
    <div class="hsarticle-bottom">
      <div v-if="download" class="hsarticle__download">
        <Download :file="download" />
      </div>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="hsarticle__title">
      <nuxt-link
        v-if="checkHsAccess(tags)"
        :to="link"
        class="hsarticle__title-link"
        target="_blank"
        v-html="title"
      />
      <nuxt-link v-else :to="link" class="unauthorised hsarticle__title-link">{{
        noAccessShort
      }}</nuxt-link>
    </div>
    <div
      v-if="desc && checkHsAccess(tags)"
      class="hsarticle__desc"
      v-html="externalLinks(desc)"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div
      v-if="desc && !checkHsAccess(tags)"
      class="unauthorised hsarticle__desc"
    >
      {{ noAccessShort }}
    </div>
    <div v-if="date" class="hsarticle__date">
      <Date :text="date" :author="author" />
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapState } from "vuex";
// import config from "../../nuxt.config";
import { noAccessShort, checkAccess } from "@/utils/constants";
import { links } from "@/mixin/links";
export default {
  name: "HsArticle",
  components: {
    Tag: () => import("../elements/Tag"),
    Date: () => import("../elements/Date"),
  },
  mixins: [links],
  props: {
    tags: {
      type: [Array, String],
      default: null,
    },
    reports: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    desc: {
      type: String,
      default: null,
    },
    date: {
      type: [String, Number],
      default: null,
    },
    author: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: "/",
    },
    image: {
      type: String,
      default: null,
    },
    download: {
      type: String,
      default: null,
    },
    bigImage: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
    productAccess: {
      type: [Array, Number],
      default: null,
    },
    updates: {
      type: Boolean,
      default: false,
    },
    isPremiumReport: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "",
    },
    watchlistTags: {
      type: [Array, Number],
      default() {
        return [];
      },
    },
    classification: {
      type: String,
      default: null,
    },
    overrideAccess: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    notSubscribe: false,
    noAccessShort,
  }),
  computed: { ...mapState("Auth", ["subscriptions"]) },
  watch: {},
  mounted() {},
  methods: {
    setTagColour(col) {
      if (col === "Informative") {
        return "green";
      }

      if (col === "Indicative") {
        return "orange";
      }

      if (col === "Actionable") {
        return "red-filled";
      }
    },
    setTagURL(link, type) {
      let newLink = "";
      newLink = "/search?filter[" + type + "][]=" + link.tid;
      return newLink;
    },
    checkHsAccess(tags) {
      // The newer API will only return content you have access to and therefore this check is not needed.
      // However the tids are still required for legacy permissions.
      const tids = [];
      for (let i = 0; i < tags.length; i++) {
        if (tags[i].tid) {
          tids.push(tags[i].tid);
        }
      }
      return (
        this.overrideAccess ||
        checkAccess(
          this.$store.state.Auth.subscriptions.permissions,
          "hs"
        ) ||
        checkAccess(this.$store.state.Auth.subscriptions.legacy_permissions, "viewHorizonScanning", tids)
      );

    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.hsarticle {
  margin-bottom: 3.2rem;
  border-bottom: 1px solid $border;
  position: relative;

  padding-bottom: 30px;
  &.border {
    .hsarticle__title {
      border-top: 1px solid $border;
      padding-top: 1rem;
    }
  }

  &-small {
    .hsarticle__title {
      @include below($md) {
        padding-right: 0.7em;
      }

      &-link {
        font-size: 1.8rem;
        line-height: 2.3rem;
      }
    }
    .hsarticle__desc {
      font-size: 1.4rem;
      line-height: 2rem;
    }
    .hsarticle__image {
      height: 17rem;
    }
  }

  &__tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
    //border-bottom: 1px solid #b1b3b3;
    margin-bottom: 1.2rem;
    &-more {
      margin-left: 1rem;
      font-weight: 600;
    }
  }

  &__report {
    display: flex;
    margin-bottom: 1.2rem;
  }

  &__title {
    margin-bottom: 1rem;

    &-link {
      color: $text_gray;
      font-size: 2.8rem;
      line-height: 3.3rem;
      font-weight: 700;
      text-decoration: none;
      transition: 0.3s ease-out;

      &:hover {
        color: $brightGreen;
      }

      @include below($md) {
        font-size: 2rem;
        line-height: 2.4rem;
      }
    }
  }
  &__desc {
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: $text_gray;
    margin-bottom: 1rem;
    padding-right: 1rem;
  }
  &__image {
    width: 100%;
    height: 27rem;
    display: block;
    margin-bottom: 1.6rem;
    transition: 0.3s ease-out;

    &:hover {
      opacity: 0.7;
    }

    &--big {
      height: 34rem;
    }

    @include below($md) {
      height: 20rem;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &-bottom {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  mark {
    background-color: #eae6c5;
  }

  &__updates {
    .hsarticle__title-link {
      font-size: 1.4rem !important;
      line-height: 1.65rem;
    }
  }
}
</style>
